import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const patchUser = async (params) => {
  const res = await axiosInstance.post(API_ROUTES.UserRegister, { user: params })
  return res.data
}

export default patchUser
